<script setup lang="ts">
const { content } = defineProps<{
  content?: string
}>()
</script>

<template>
  <p class="text-sm text-base-content/70 w-full md:w-2/3">
    <slot>
      {{ content }}
    </slot>
  </p>
</template>
